import React from 'react';
import { Link } from 'react-router-dom'
import PicturePreview from './PicturePreview';
import { setSelfieVideo, setIdCardImage, setIdCardImageBack, setCheckinCurrentPageName } from '../../action/autoCheckin';
import { connect } from 'react-redux';
import closeIcon from '../../images/icons/close_icon.svg';
import { setGoHome } from '../../action/homeAction'
import Camera from './Camera';
import { mobileCheckinColorConfig } from '../../JS/colorConfig'
import LivelinessTip from './livelinessTip'
import {withTranslation} from 'react-i18next'
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import { sendAnalytics } from '../../../action/homeAction';
import { CMSPath } from '../../../config/constant';

class VerifyIdentity extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      videoUrl: '',
      images: [],
      test: '',
      error: '',
      new_data: '',
      data: '' ,
      showPicturePreview: false,
      cameraPrev:false 
    }
    this.cameraSuccess = this.cameraSuccess.bind(this);
   
  }

  cameraSuccess(mediaFile, isLast=false) {

    let files = [...this.state.images]
    files.push(mediaFile);
    this.setState({images: files});

    if (isLast){
      this.setState({
        videoUrl: `${mediaFile}`,
        showPicturePreview: true 
      })
      this.props.setSelfieVideo({videoUrl: `${mediaFile}`, images: files});
      // console.log(`images: ${this.state.images.join(",")}`);
    }
  }

  componentDidUpdate(){
    mobileCheckinColorConfig(this.props.menuColor);
  }

  componentDidMount() {
    window.scrollTo(0,0);
    mobileCheckinColorConfig(this.props.menuColor);

    const checkin_selfie_capture_event_sent = localStorage.getItem("checkin_selfie_capture_event_sent");
    // Send Analytics
    if(!checkin_selfie_capture_event_sent){
      let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
      this.props.sendAnalytics(
          null, 
          this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
          "SELFIE - CAPTURE", 
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "selectedIdType": this.props.selectedIdType.key, "pageName": "SELFIE - CAPTURE", "widgetSessionId": localStorage.getItem("checkinSessionToken")}, 
          0, 
          false,
          () => localStorage.setItem("checkin_selfie_capture_event_sent", true)
      );
    }
    this.props.setCheckinCurrentPageName("SELFIE - CAPTURE")
    //
  }
  
  render() {
    const {t} = this.props
    return (
      /*
      this.state.showPicturePreview ? <PicturePreview image = {this.state.videoUrl} video = {false} selfie = {true}
      cameraSuccess = {this.cameraSuccess} hidePicturePreview = {() => this.setState({showPicturePreview:false})}
      cameraFailure={this.cameraFailure} setOptions={this.setOptions}
      nextPath={'/checkin/confidence/'}
      />*/

      this.state.cameraPrev ? <Camera nextScreen={this.props.setConfidanceScreen} nextPath={'/checkin'} selfie = {true} 
      saveImage = {this.cameraSuccess} image = {this.state.videoUrl} backBtn = {() => this.setState({cameraPrev:false})}
      click_single_picture={false} recordVideo={false} messages={["Detecting liveliness...", "Taking selfie..."]} switchUsingNextScreen={true}/>

      :<div className="main-container">
        <header className="inner-pages w-footer subpages">
          <a onClick={() => {
              this.props.setSelfieVideo(null);
              // this.props.setIdCardImage(null);
              // this.props.setIdCardImageBack(null);
              // this.props.setSelectedIdType(null);
              this.props.goBack();
            }} className="button-back"></a>
          <div className="heading align-center">
            <div class="splash-brand">
                  <img src={`${CMSPath}${this.props.logo}`} />
              </div>
            {/* <p className="bold" style = {{color:"inherit"}}>{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
          </div>
        </header>
        <section className="widgets padding-0 margin-0 container-bg">
        
          <div class="widget-header widget-header-checkin-inner">
              { this.props.currentWidgetObj.widgetHeaderImageUrl && 
                  <div class="widget-header-img">
                      <img src={`${CMSPath}${this.props.currentWidgetObj.widgetHeaderImageUrl}`} alt={this.props.currentWidgetObj.displayName} />
                  </div>
              }
              <div class="widget-header-title">{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
          </div>

          <div className="widgets">
            <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
              <h2 className = "all-caps"></h2>
            </div>
            <div className="form-window">
              <div className="form-window-heading">
              {t('check_in.verify_identity')}
              </div>
              <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                {!this.props.selfieVideo && <div className="form-row margin-bottom-2">
                  <label>{t('check_in.take_selfie')}</label>
                  <label for="photoId" className="photo-uploader" onClick={() => {
                    this.setState({cameraPrev:true})
                    // if(navigator.device) {
                    //   navigator.device.capture.captureVideo(this.cameraSuccess, this.cameraFailure,{duration:3});
                    // } else {
                    //   console.log('navigator is null', navigator, navigator.device);
                    // }
                    /*
                    if (navigator.camera){
                      var srcType = navigator.camera.PictureSourceType.CAMERA;
                      var options = this.setOptions(srcType); 
                      navigator.camera.getPicture(this.cameraSuccess, this.cameraFailure, options);
                    }*/
                  }}>{t('check_in.take_a_picture_of_yourself')}</label>
                  {/* <input name="photoId" id="photoId" type="file" /> */}
                </div>}

                {/* {this.props.selfieVideo && <div style = {{display:'flex'}}>
                  <p style = {{width:'85%',overflow:'hidden'}}>video</p>
                  <img src = {closeIcon} className = "selfie_video_delete_icon" onClick = {() => this.props.setSelfieVideo(null)}/>
                </div>} */}

                {this.props.selfieVideo && <div style = {{background:"#000",height: "300px",marginBottom:'20px',position:'relative'}}>
                    <img src = {closeIcon} className = "id_image_delete_icon" onClick = {() => this.props.setSelfieVideo(null)} style={{width: '20px', position:'absolute',top:'10px',right:'10px',zIndex:'5'}}/>
                    <img src = {`${this.props.selfieVideo.videoUrl}`} height = "100%" width = "100%" style = {{marginBottom: '10px',objectFit: 'contain'}}/>
                  </div> }

                <div className="form-row disclaimer margin-top-2 margin-bottom-2">
                  <p>*{t('check_in.keep_straight_face')}</p>
                  <p>**{t('check_in.remove_objects')}</p>
                  <p>***{t('check_in.make_sure')}</p>
                </div>
                {/* /stay-step-2/confidence */}
                <div className="form-controls">
                  {/* <Link exact to={`/checkin/confidence/`}> */}
                    <button onClick={this.props.setConfidanceScreen} className="primary w-100" disabled = {!this.props.selfieVideo ? true : false}>
                    {t('check_in.next')}
                    </button>
                  {/* </Link> */}
                  <button className="secondary w-100 margin-top-1" onClick = {() => {
                    // this.props.setGoHome(true);
                    this.props.setSelfieVideo(null);
                    // this.props.setIdCardImage(null);
                    // this.props.setIdCardImageBack(null);
                    this.props.goBack()
                    }}>{t('check_in.cancel')}</button>
                </div>
              </div>
            </div>
          </div>
      </section>
     
    </div>
    )
  }
}

const mapStateToProps = state => {
  return{
    selfieVideo: state.store2.selfieVideo,
    menuColor: state.store.home.MenuColor,
    selectedIdType: state.store2.selectedIdType,
    logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
  }
}

export default connect(mapStateToProps,{ setSelfieVideo, setGoHome, setIdCardImage, setIdCardImageBack, sendAnalytics, setCheckinCurrentPageName })(withTranslation('translations')(VerifyIdentity));